import React from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { AddressType } from "data/types";

interface AddressProps {
  className?: string;
  address?: AddressType;
  handleModify?: () => void;
  handlePrimary?: (id: string) => void;
  handleDelete?: (address: AddressType) => void;
}

const Address: React.FC<AddressProps> = ({
  className = "",
  address,
  handleModify = () => {},
  handlePrimary = () => {},
  handleDelete = () => {},
}) => {
  return (
    <div
      className={`relative border-primary-6000 border-2 ${
        address?.primary || "border-dashed"
      } rounded-lg py-5 px-10 mb-5 bg-white dark:bg-neutral-900 ${className}`}
    >
      {address?.primary || (
        <div
          className="absolute right-6 bottom-6 text-red-500"
          onClick={() => handleDelete(address!)}
        >
          Hapus
        </div>
      )}
      <div>
        <div className="flex items-center">
          <p className="text-lg font-semibold mb-1 truncate overflow-hidden">
            {address?.recipient}
          </p>
          {address?.primary && (
            <span className=" bg-primary-6000 px-3 text-white rounded-lg ml-3">
              Utama
            </span>
          )}
        </div>

        <p className="text-3xl font-bold mb-2">{address?.name}</p>
        <p className="my-2">62{address?.phone}</p>
        <p className="my-2">{address?.fullAddress}</p>
        <div
          className={`grid ${
            address?.primary || "grid-rows-2 sm:grid-rows-1"
          } sm:grid-cols-2 w-max gap-3`}
        >
          <ButtonSecondary className="rounded-lg" onClick={handleModify}>
            Ubah Alamat
          </ButtonSecondary>
          {address?.primary || (
            <ButtonPrimary
              className="rounded-lg bg-white"
              onClick={() => handlePrimary(address?._id as string)}
            >
              <span className="text-sm">Jadikan Alamat Utama</span>
            </ButtonPrimary>
          )}
        </div>
      </div>
    </div>
  );
};

export default Address;
